import { useRef } from 'react';

/**
 * A hook that provides refs to track hydration and dirty state.
 *
 * Useful for forms that need to:
 * 1. Load initial data once (hydration tracking)
 * 2. Only save when the user actually changes something (dirty tracking)
 *
 * @example
 * const { hydratedRef, dirtyRef } = useHydrationTracking();
 *
 * // On load, hydrate once
 * useEffect(() => {
 *   if (!hydratedRef.current && externalData) {
 *     setValue(externalData);
 *     hydratedRef.current = true;
 *   }
 * }, [externalData]);
 *
 * // On change, mark as dirty
 * const handleChange = (newValue) => {
 *   dirtyRef.current = true;
 *   setValue(newValue);
 * };
 */
export const useHydrationTracking = () => {
    const hydratedRef = useRef(false);
    const dirtyRef = useRef(false);

    return {
        hydratedRef,
        dirtyRef,
    };
};
